import { render, staticRenderFns } from "./WizardTeamMemberEditor.vue?vue&type=template&id=6b7ee713&scoped=true&"
import script from "./WizardTeamMemberEditor.vue?vue&type=script&lang=ts&"
export * from "./WizardTeamMemberEditor.vue?vue&type=script&lang=ts&"
import style0 from "./WizardTeamMemberEditor.vue?vue&type=style&index=0&id=6b7ee713&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7ee713",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b7ee713')) {
      api.createRecord('6b7ee713', component.options)
    } else {
      api.reload('6b7ee713', component.options)
    }
    module.hot.accept("./WizardTeamMemberEditor.vue?vue&type=template&id=6b7ee713&scoped=true&", function () {
      api.rerender('6b7ee713', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wizard/WizardTeamMemberEditor.vue"
export default component.exports